import { Component, EventEmitter , Input , Output,OnInit } from '@angular/core';
import {ViewCell} from '../../ng2-smart-table/components/cell/cell-view-mode/view-cell';


@Component({
  selector: 'app-table-funnel-columns',
  templateUrl: './table-funnel-columns.component.html',
  styleUrls: ['./table-funnel-columns.component.scss']
})

export class TableFunnelColumnsComponent implements ViewCell, OnInit {

  	@Input() value: string | number;
  	@Input() rowData: any;

	@Output() redirectToAnotherPage: EventEmitter<any> = new EventEmitter();

	constructor() { }
	  
  	colData : any;
  	eventNumber : number | any;
  	eventPercentage : string;
  	percentCompareValue : string;  
  	percentCompareClass : string;
	showPercentStatus : boolean;
	showSimpleColumn : boolean;    // this flag is whether to show simple value count or on false show modifed styled div
	showSimpleColumnVal: String | any;
	
	isDataPointClick: boolean;     // flag to decide whether this column is insights data point clickable to redirect detailed logs
	dataRedirectTo : string;
	dataPointSummryBy: string;     // if isDataPointClick true then summary column  
	dataPointSummryValue: string;  // if isDataPointClick true then summary column actual row value

	ngOnInit() {

		//console.log( " rowData ", this.rowData )
  		this.colData = this.value;   // get column specific data
  		this.showPercentStatus = true;
		this.showSimpleColumn = false;   // default false
		this.showSimpleColumnVal = ''; 
		
		//console.log( " colData ", this.colData )
		
		this.isDataPointClick = false    // default false
		this.dataPointSummryBy = '';
		this.dataPointSummryValue = '';

  		this.eventNumber = this.colData.count;
		this.eventPercentage = this.colData.percent;

		if( this.colData['isDataPoint'] || this.colData['showSimpleColumn'] ){

			if( this.colData['isDataPoint']  ){
				this.isDataPointClick = true;
				this.dataPointSummryBy = this.colData['summarize_by'];
				this.dataPointSummryValue = ( this.rowData[this.colData['firstColName']] !== undefined ) ? this.rowData[this.colData['firstColName']] : this.rowData['summary_by'];
				this.dataRedirectTo = this.colData['redirectTo'];
			}
			if( this.colData['showSimpleColumn'] ){
				this.showSimpleColumn = true;
				this.showSimpleColumnVal = ( ( this.colData['colValue'] ) ? this.colData['colValue'] : this.rowData[ this.colData['colName'] ] );
			}

			if( this.eventNumber !== undefined ){
				this.isDataPointClick = parseFloat( this.eventNumber ) > 0 ? true : false;
			}

			if( this.showSimpleColumnVal ){
				this.isDataPointClick = parseFloat( this.showSimpleColumnVal ) > 0 ? true : false;
			}
			
		}
			
		if((! this.colData.compare_percent_status) || this.colData.compare_percent_status == "0" ){
			this.showPercentStatus = false;
			// this.percentCompareValue = "-"; 
		}
		else{
			this.percentCompareValue = this.colData.compare_percent_value; 
			this.percentCompareClass = this.getColor( this.colData.compare_percent_status );	
		}
  	}

  	getColor( status ){

  		if( status == '1' ){    // high
	  		return "number-color-box-success";
	  	}
      	else if(status == '0'){    // no change
	  		return "number-color-box-secondary";	  		
	  	}
      	else{   				// low
  			return "number-color-box-primary";
	  	}
	}
	
	onClick() {

		let emitData = {
			redirectTo : this.dataRedirectTo,
			SummarizeBy : this.dataPointSummryBy,
			summarizeValue : this.dataPointSummryValue,
			columnValue : ( this.eventNumber !== undefined ) ? this.eventNumber : this.showSimpleColumnVal
		}
		this.redirectToAnotherPage.emit( emitData );		
	}


}
